<template>
  <div class="content">
    <crear-procedure @update="update"> </crear-procedure>
    <div class="container-fluid h-100">
      <div class="container-fluid h-100">
        <div class="row h-100">
          <div class="col h-100">
            <card-item
              class="striped-tabled-with-hover"
              body-classes="table-full-width table-responsive"
            >
              <template slot="header">
                <div class="d-flex justify-content-between">
                  <div>
                    <h4 class="card-title">Modificando Rol: {{ nombre }}</h4>
                    <p class="card-category">Permisos</p>
                  </div>
                  <button
                    @click="$bvModal.show('createProcedure')"
                    class="btn btn-success"
                  >
                    <i class="fas fa-user-plus"></i>
                    Crear procedimiento
                  </button>
                </div>
              </template>
              <div class="container-fluid h-100">
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <label for="quickFilter" class="label"
                        >Filtro rapido</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="quickFilter"
                        v-model="filtroRapido"
                      />
                    </div>
                  </div>
                </div>
                <div class="row" style="height: 100%">
                  <div class="col" style="position: relative; height: 100%">
                    <ag-grid-vue
                      style="width: 100%; height: 60vh"
                      class="ag-theme-alpine"
                      :columnDefs="columnDefs"
                      :rowData="procedures"
                      :rowSelection="'multiple'"
                      :rowMultiSelectWithClick="true"
                      @grid-ready="onGridReady"
                      :gridOptions="gridOptions"
                      :getContextMenuItems="getContextMenuItems"
                    >
                    </ag-grid-vue>
                  </div>
                </div>
                <div class="d-flex justify-content-between m-2">
                  <button @click="volver" class="btn btn-danger">Volver</button>
                  <button @click="submit" v-promise-btn class="btn btn-primary">
                    Confirmar
                  </button>
                </div>
              </div>
            </card-item>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { get } from "lodash-es";
import { AgGridVue } from "ag-grid-vue";
import CrearProcedure from "../CrearProcedure";
import axios from "axios";

export default {
  name: "ModificarRol",
  components: {
    AgGridVue,
    CrearProcedure,
  },
  data: () => ({
    procedures: [],
    columnDefs: [
      {
        flex: 1,
        field: "id_procedure",
        headerCheckboxSelection: true,
        checkboxSelection: true,
        showDisabledCheckboxes: true,
        sortable: true,
        comparator: (a, b, nodeA, nodeB) => {
          if (nodeA.isSelected() && !nodeB.isSelected()) {
            return -1;
          } else if (!nodeA.isSelected() && nodeB.isSelected()) {
            return 1;
          } else {
            return nodeA.data.id_procedure
              .toString()
              .localeCompare(nodeB.data.id_procedure.toString());
          }
        },
      },
      {
        field: "nombre",
        flex: 2,
      },
      {
        field: "comentarios",
        flex: 2,
      },
    ],
    rolId: null,
    nombre: null,

    filtroRapido: "",

    nodos: [],
    proceduresDelRol: [],
    gridApi: null,
    gridColumnApi: null,

    gridOptions: {
      enableClipboard: true,
      enableRangeSelection: true,
      suppressCopyRowsToClipboard: false,
    },
  }),
  mounted() {
    this.rolId = this.$router.currentRoute.params.id_rol;
  },
  methods: {
    volver() {
      this.$router.push(`/admin/roles/`);
    },
    update() {
      this.getData();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;

      this.getData();
    },
    getContextMenuItems() {
      return ["copy", "excelExport"];
    },
    async getData() {
      this.gridApi.showLoadingOverlay();

      const resp = await axios.post("/execute", {
        method: "SEC.GetProceduresByRolId",
        parameters: [{ name: "id_rol", value: this.rolId }],
      });
      if (resp.data.ok) {
        this.proceduresDelRol = get(resp, "data.result[0]", []);
        this.nombre = get(resp, "data.result[0][0].RolNombre", "");
      } else {
        this.$msgBoxOk(resp.data.message);
      }

      const respProcedures = await axios.post("/execute", {
        method: "SEC.GetProcedures",
        parameters: [],
      });
      if (respProcedures.data.ok) {
        this.procedures = get(respProcedures, "data.result[0]", []);
      } else {
        this.$msgBoxOk(respProcedures.data.message);
      }

      setTimeout(() => {
        this.pintarSeleccionados();
        this.gridApi.hideOverlay();
      }, 0);
    },
    pintarSeleccionados() {
      const obj = {};
      this.proceduresDelRol.forEach((pr) => (obj[pr.id_procedure] = pr));

      this.gridApi.forEachNode((node) => {
        if (obj[node.data.id_procedure]) {
          node.setSelected(true);
        }
      });

      this.gridColumnApi.applyColumnState({
        state: [{ colId: "id_procedure", sort: "asc", sortIndex: 0 }],
      });
    },

    async submit() {
      const nodos = this.gridApi.getSelectedNodes();

      const mapProcedures = nodos.map((nodo) => nodo.data.id_procedure);

      try {
        const resp = await axios.post("/execute", {
          method: "SEC.AsignarProcedimientosARol",
          parameters: [
            { name: "id_rol", value: this.rolId },
            {
              name: "proceduresIds",
              value: mapProcedures.join(","),
            },
          ],
        });

        if (resp.data.ok) {
          await this.getData();
        } else {
          this.$msgBoxOk(resp.data.message);
        }
      } catch (error) {
        this.$bvModal.message(error.message);
      }
    },
  },
  watch: {
    filtroRapido(val) {
      this.gridApi.setQuickFilter(val);
    },
  },
};
</script>
